
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/[locale]/produtos/hub-talentos",
      function () {
        return require("private-next-pages/[locale]/produtos/hub-talentos.page.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/[locale]/produtos/hub-talentos"])
      });
    }
  